// SPDX-License-Identifier: AGPL-3.0-or-later

import type {LimitKey} from '@konvo/constants/src/LimitConfigMetadata';
import type {ILimitConfigCodec} from '@konvo/limits/src/ILimitConfigCodec';
import {LimitConfigCodec} from '@konvo/limits/src/LimitConfigCodec';
import type {LimitConfigSnapshot, LimitConfigWireFormat} from '@konvo/limits/src/LimitTypes';

const defaultLimitConfigCodec = new LimitConfigCodec();

export function createLimitConfigCodec(): ILimitConfigCodec {
	return new LimitConfigCodec();
}

export function computeOverrides(
	fullLimits: Partial<Record<LimitKey, number>>,
	defaults: Record<LimitKey, number>,
): Partial<Record<LimitKey, number>> {
	return defaultLimitConfigCodec.computeOverrides(fullLimits, defaults);
}

export function computeWireFormat(config: LimitConfigSnapshot): LimitConfigWireFormat {
	return defaultLimitConfigCodec.toWireFormat(config);
}

export function expandWireFormat(wireFormat: LimitConfigWireFormat): LimitConfigSnapshot {
	return defaultLimitConfigCodec.fromWireFormat(wireFormat);
}
